export const HERO_CONTENT_IMAGE_VARIANTS = [
  { suffix: 'ExLg', media: '(min-width: 1600px)' },
  { suffix: 'Lg', media: '(min-width: 768px) and (max-width: 1599px)' },
  { suffix: 'Sm', media: '(max-width: 767px)' },
];

export const getHeroContentImageSources = (content, imageType) =>
  HERO_CONTENT_IMAGE_VARIANTS.map(({ suffix, media }) => ({
    suffix,
    media,
    avif: content.metadata(`hero${imageType}${suffix}Avif`).value(),
    backup: content.metadata(`hero${imageType}${suffix}Backup`).value(),
  }));
